import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class MmuFaviconService {

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init(): void {
    this.initIcons();
    this.initExtras();
  }

  setStatus(status?: 'loading' | 'notification'): void {
    this.removeIcons();
    switch (status) {
      case 'loading':
        this.addLinkIcon('/assets/favicons/anim.gif', '32x32', 'image/gif');
        break;
      case 'notification':
        this.addLinkIcon('/assets/favicons/favicon-notification.png', '32x32', 'image/png');
        break;
      default:
        this.reset();
    }
  }

  reset(): void {
    this.removeIcons();
    this.initIcons();
  }

  private addLinkNode(href: string, rel: string, sizes?: string, imageType?: string, color?: string): void {
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'rel', rel);
    this.renderer.setAttribute(linkElement, 'href', href);

    if (imageType) {
      this.renderer.setAttribute(linkElement, 'type', imageType);
    }

    if (sizes) {
      this.renderer.setAttribute(linkElement, 'sizes', sizes);
    }

    this.renderer.appendChild(document.head, linkElement);
  }

  private addLinkIcon(href: string, sizes: string, type: string): void {
    this.addLinkNode(href, 'icon', sizes, type);
  }

  private addLinkApple(href: string, sizes: string): void {
    this.addLinkNode(href, 'apple-touch-icon', sizes);
  }

  private addManifest(href: string): void {
    this.addLinkNode(href, 'manifest');
  }

  private addMaskIcon(href: string, color: string): void {
    this.addLinkNode(href, 'mask-icon', undefined, undefined, color);
  }

  private addMeta(name: string, content: string): void {
    const metaElement = this.renderer.createElement('meta');
    this.renderer.setAttribute(metaElement, 'name', name);
    this.renderer.setAttribute(metaElement, 'content', content);
    this.renderer.appendChild(document.head, metaElement);
  }

  private removeIcons(): void {
    const el = document.head.querySelectorAll('link[rel=icon]');
    el.forEach(e => {
      this.renderer.removeChild(e.parentElement, e);
    });
  }

  private initExtras(): void {
    this.addLinkApple('/frontend-container/assets/favicons/apple-touch-icon.png', '128x128');
    this.addMaskIcon('/frontend-container/assets/favicons/safari-pinned-tab.svg', '#fff');
    this.addManifest('/frontend-container/assets/favicons/site.webmanifest');
    this.addMeta('msapplication-TileColor', '#fff');
    this.addMeta('theme-color', '#fff');
  }

  private initIcons(): void {
    this.addLinkIcon('/frontend-container/assets/favicons/favicon-32x32.png', '32x32', 'image/png');
    this.addLinkIcon('/frontend-container/assets/favicons/favicon-16x16.png', '16x16', 'image/png');
  }
}
